export default __webpack_public_path__ + "static/media/slider_image_01-md@2x.d2894b97.jpg";